import React, { Component } from 'react';

//components
import MultiUploadFileBox from "../../../../generic_components/components/upload_file_boxes/MultiUploadFileBox";
import CustomButton from "../../../../generic_components/components/buttons/CustomButton";
import HtmlTextBlock from "../../../../generic_components/components/text_display/HtmlTextBlock";
import LoadingPgTemplate from "../../../../generic_components/view/LoadingPgTemplate";

//generic functions
import {
    isEmpty,
    cloneObject
} from "../../../../functions/generic_functions";

//router
import { withRouter } from 'react-router-dom';

//import static routes
import { 
    cari_api_load_reference_data_url,
    cari_api_save_reference_data_url,
    cari_reference_submitted_url 
} from "../../../../router/static_routes";

//redux
import { connect } from "react-redux";
import {
    openCariModal
} from "../../../../redux/actions/indexActions";

//redux mapper
const mapDispatchToProps = dispatch => {
    return {
        openCariModal: (modal_data) => {
            dispatch(openCariModal(modal_data))
        },
    };
};

class CariReferencePg extends Component {

    state = {
        mounted: false,
        pageLoaded: false,

        helpcontactEmail: "bsb_appointments@sfu.ca",

        staticUiData: {
            applicant_first_name: "Applicant First Name",
            applicant_last_name: "",
            referee_relationship: "",
            referee_company: "",
            position_title: "Position Title",
        },
        postData: {
            referenceCode: null, //retrieved from url
            referenceLetter: null,//note reference data is not loaded 
        },
        formData: new FormData(),
    }

    constructor(Props) {
        super(Props);

        //handlers
        this.handleOnChangeSetParentState = this.handleOnChangeSetParentState.bind(this);
        this.handleOnSubmitDeclineReference = this.handleOnSubmitDeclineReference.bind(this);
        this.handleOnSubmitAcceptReference = this.handleOnSubmitAcceptReference.bind(this);

        //load page data from api
        this.load_page_data_from_api = this.load_page_data_from_api.bind(this);

        //ui render
        this.renderReferenceParagraph = this.renderReferenceParagraph.bind(this);
        
        //helper functions
        this.submitReference = this.submitReference.bind(this);
    }

    /*
          post parameters {
              referenceCode,
          }
  
          return data {
              status => true/false
              message {
                  staticUiData {
                    applicant_first_name: "",
                    applicant_last_name: "",
                    referee_relationship: "",
                    referee_company: "",
                    position_title: "Position Title",
                  }
                  responseReceived: true/false
              }
          }
      */
    load_page_data_from_api() {

        //get referenceCode 
        var referenceCode = this.state.postData.referenceCode;
  
        var form_data = new FormData();

        //add form data
        form_data.append("referenceCode", referenceCode);

        //post request to verify code
        fetch(cari_api_load_reference_data_url, {
            method: 'POST',
            body: form_data,
            headers: {
                'Accept': 'application/json',
            }
        }).then((response) => {
            //only continue fetch if mounted
            if (this.state.mounted) {
                var responseHttpCode = response.status;
                //good request
                if (responseHttpCode === 200) {
                    return response.json();
                }
                //bad request
                else {
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "Bad Request. Please refresh the page to try again.",
                    });
                }
            }
        }).then(json => {
            //successfully processed request
            if (!isEmpty(json)
                && !isEmpty(json.status)
                && json.status  
                && !isEmpty(JSON.parse(json.message))
            ) {
                var json_data = JSON.parse(json.message);

                var responseReceived = json_data.responseReceived;
                
                //if response received is null display modal saying invalid data
                if (responseReceived == null) {
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "Invalid Data. Please refresh the page to try again.",
                    });
                }
                //if respopnse has already been received redirect to submitted page
                else if (responseReceived) {
                    this.props.history.push(cari_reference_submitted_url);
                }
                //if response has not been received allow user to submit response
                else {
                    var fetchedPageData = json_data;
                    var fetchedStaticUiData = fetchedPageData.staticUiData;

                    //init copy of post data of local state
                    var copyStaticUiData = cloneObject(this.state.staticUiData);
                    //loop through fetched page data and set the state values if they are not empty
                    if (!isEmpty(fetchedStaticUiData)) {
                        copyStaticUiData = fetchedStaticUiData;
                    }

                    this.setState({
                        pageLoaded: true,
                        staticUiData: copyStaticUiData
                    });
                }
            }
            //if api returns no data, popup modal and on click of ok, refresh page 
            else {
                // this.props.openCariModal({
                //     modalId: "errorModal",
                //     title: "Failed to retrieve data. Please refresh the page to try again.",
                // });
            }
        })
        //if api is not found
        .catch((error) => {
            console.log(error);
            this.props.openCariModal({
                modalId: "errorModal",
                title: "Something went wrong. Please refresh the page to try again.",
            });
        });
    }

    componentDidMount() {
        //get referenceCode from parameter of match and set it for state
        var referenceCode = this.props.match.params.referenceCode;
        var copyPostData = cloneObject(this.state.postData);
        copyPostData.referenceCode = referenceCode;

        this.setState({
            mounted: true,
            postData: copyPostData,
        }, () => {
            //load page data
            this.load_page_data_from_api();
        });
    }

    componentWillUnmount() {
        this.setState({
            mounted: false
        });
    }

    /*
        call an API to set reference to accepted status and upload file

        post parameters {
            referenceCode,
            referenceAcceptanceStatus
        }

        return data {
            status => true/false
            message {
                referenceSubmitted: true/false
            }
        }

    */
    handleOnSubmitAcceptReference() {
        this.submitReference(true);
    }

    handleOnSubmitDeclineReference() {
        this.submitReference(false);
    }

    submitReference(referenceAcceptanceStatus) {
        //add referenceAcceptanceStatus as false to postData
        var copyPostData = cloneObject(this.state.postData);

        //add form data
        this.state.formData.append("referenceCode", copyPostData.referenceCode);
        this.state.formData.append("referenceAcceptanceStatus", referenceAcceptanceStatus);

        //post referenceCode and response
        fetch(cari_api_save_reference_data_url, {
            method: 'POST',
            body: this.state.formData,
            headers: {
                'Accept': 'application/json',
            }
        }).then((response) => {
            //only continue fetch if mounted
            if (this.state.mounted) {
                var responseHttpCode = response.status;

                //good request
                if (responseHttpCode === 200) {
                    return response.json();
                }
                //bad request
                else {
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "Bad Request, please try again."
                    });
                }
            }
        }).then(json => {
            //successfully processed request
            if (!isEmpty(json)
                && !isEmpty(json.status)
                && json.status
                && !isEmpty(JSON.parse(json.message))
            ) {
                var json_data = JSON.parse(json.message);
                var referenceSubmitted = json_data.referenceSubmitted;
                //if submitted, redirect to submitted page
                if (referenceSubmitted) {
                    this.props.history.push(cari_reference_submitted_url);
                }
                //if failed to submit, popup modal
                else {
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "Failed to submit reference, please try again."
                    });
                }
            }
            //if api returns no data, popup modal 
            else {
                // this.props.openCariModal({
                //     modalId: "errorModal",
                //     title: "Failed submit reference, please try again.",
                // });
            }
        })
            //if api is not found
            .catch((error) => {
                console.log(error);
                this.props.openCariModal({
                    modalId: "errorModal",
                    title: "Something went wrong, please try again."
                });
            });
    }

    /*
        %applicant_first_name% %applicant_last_name% has applied for the position of %position_title% at the Beedie School of Business at Simon Fraser University. Please attach your letter of recommendation in support of %applicant_first_name% %applicant_last_name%'s application outlining your experience with the applicant, as their %referee_relationship% at %referee_company% below:
    */
    renderReferenceParagraph() {

        var referenceParagraph = "";
        var applicant_full_name = this.state.staticUiData.applicant_first_name + " " + this.state.staticUiData.applicant_last_name;

        var referee_relationship = this.state.staticUiData.referee_relationship;
        var referee_company = this.state.staticUiData.referee_company;
        var position_title = this.state.staticUiData.position_title;

        //build paragraph
        referenceParagraph = "<strong>" + applicant_full_name + "</strong> has applied for the position of <strong>" + position_title + "</strong> at the Beedie School of Business at Simon Fraser University. Please attach your letter of recommendation in support of <strong>" + applicant_full_name + ((!isEmpty(applicant_full_name) && applicant_full_name[applicant_full_name.length - 1].toLowerCase() === "s") ? "'" : "'s") + "</strong> application outlining your experience with the applicant, as their <strong>" + referee_relationship + "</strong> at <strong>" + referee_company + "</strong> below:";
        
        return referenceParagraph;
    }

    //handles on change events for setting states for form input for post data
    //action comes as "add", "replace"
    handleOnChangeSetParentState(fileObj, nameKey, action) {

        var copyPostData = cloneObject(this.state.postData);
        //save the reference letter
        if (nameKey === "referenceLetter") {

            var file = fileObj.file;
            var fileName = fileObj.fileName;
            var fileSize = fileObj.fileSize;

            //if action is add
            if(action === "add") {

                //save format for file:
                /*
                    referenceLetter {
                        fileName:
                        fileSize:
                        file: 
                    }
                */
               var newFormData = new FormData();
               newFormData.append("supporting_doc", fileObj.file)
               this.setState({
                   formData: newFormData,
               });

                var referenceLetter = {
                    file: file,
                    fileName: fileName,
                    fileSize: fileSize
                }
                copyPostData.referenceLetter = referenceLetter;

                this.setState({
                    postData: copyPostData,
                })
            }
            else if (action === "replace") {
                var newFormData = new FormData();
                newFormData.append("supporting_doc", fileObj.file)
                this.setState({
                    formData: newFormData,
                });

                var referenceLetter = {
                    file: file,
                    fileName: fileName,
                    fileSize: fileSize
                }
                copyPostData.referenceLetter = referenceLetter;
                this.setState({
                    postData: copyPostData,
                })
            }
        }
    }

    render() { 
        //push reference file into an array
        const files = [];
        if (!isEmpty(this.state.postData.referenceLetter)) {
            files.push(this.state.postData.referenceLetter);
        }
        return (
            <div className="scene_element scene_element--fadeinright">
                {(!this.state.pageLoaded) ?
                    <LoadingPgTemplate />
                    : null}
                
                <div className={((this.state.pageLoaded) ? "" : "display_none")}>
                    <div className="full_page_format">
                        <br/>

                        <div className="p-grid">
                            <div className="p-col-12">

                                <div className="p-grid">
                                    <div className="p-col-6 padding-right_style_col">
                                        <label className="cari_title">
                                            Reference Form for {this.state.staticUiData.applicant_first_name} 
                                            &nbsp; 
                                            {this.state.staticUiData.applicant_last_name}
                                        </label>
                                    </div>   
                                </div>     

                                <br/>

                                <div className="p-grid">
                                    <div className="p-col-12 padding-right_style_col">
                                        <HtmlTextBlock
                                            text={this.renderReferenceParagraph()}
                                            className={"cari_small_text"}
                                        />
                                    </div>
                                </div>

                                <br/>
                                <br/>
                            
                                <div className="p-grid">
                                    <div className="p-col-6 padding-right_style_col">
                                        <strong>
                                            Reference Letter <strong className="sfu_red">*</strong>
                                        </strong>
                                    </div>
                                    <div className="p-col-6 padding-left_style_col">
                                        <MultiUploadFileBox
                                            files={files}
                                            name={"referenceLetter"}
                                            required={true}
                                            onChangeSetParentState={this.handleOnChangeSetParentState}
                                            uploadBySubmit={true}
                                            displayComment={false}
                                        />
                                    </div>
                                </div>

                                <div className="p-grid reference_padding_top"> 
                                    <div className="p-col-6">
                                        <CustomButton
                                            label={"Decline Request"}
                                            className={"p-button-danger reference_page_btn_format"}
                                            btnRound={true}
                                            btnRaised={true}
                                            onClickSetParentState={this.handleOnSubmitDeclineReference}
                                        />
                                    </div>
                                    <div className="p-col-6 pull_right">
                                        <CustomButton
                                            label={"Accept and Submit"}
                                            className={"p-button-success reference_page_btn_format"}
                                            btnRound={true}
                                            btnRaised={true}
                                            onClickSetParentState={this.handleOnSubmitAcceptReference}
                                            disabled={isEmpty(this.state.postData.referenceLetter)}
                                        />
                                    </div>
                                </div>
                                
                            </div>
                        </div>

                        <br/>
                        <br/>

                        <span className={"cari_small_text"}>
                            Should you have any questions or issues, please contact the Dean's Office, Beedie School of Business, at <strong>{this.state.helpcontactEmail}</strong>
                        </span>

                        <br/>
                        <br/>
                        <br/>
                    </div>
                </div>
            </div>
         );
    }
} export default withRouter(connect(null, mapDispatchToProps)(CariReferencePg));